module.exports = __webpack_public_path__ + "static/media/gitlab-logo.41e76cd0.svg";